import { createFileRoute } from "@tanstack/react-router"
import { AdminRevenuePage } from "../features/admin/AdminRevenuePage"

// Kein validateSearch: die Seite hat keine Filter, der Zeitraum der Zeitreihe
// ist fest (60 Tage, siehe REVENUE_SERIES_DAYS).
export const Route = createFileRoute("/_auth/admin/revenue")({
  component: AdminRevenuePage,
})
